import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import styles from './ActionStepComponent.module.scss';
import boddVariables from '../../../variables.module.scss';

interface ActionStepComponentProps {
    title: string;
    icon?: React.ReactNode;
    action?: () => void;
}

const ActionStepComponent: FC<ActionStepComponentProps> = (props) => {
    const { title, icon, action } = props;
    return (
        <div className={styles.ActionStepComponent} data-testid="ActionStepComponent">
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: '11px',
                }}
            >
                <Stack
                    direction="row"
                    spacing="12px"
                >
                    {icon}
                    <Typography sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '30px',
                        color: boddVariables.black,
                        textAlign: 'left',
                    }}
                    >
                        {title}
                    </Typography>
                </Stack>
                <Button
                    variant="contained"
                    sx={{
                        borderRadius: '48px',
                    }}
                    onClick={action}
                >
                    Book
                </Button>
            </Stack>
        </div>
    );
};

ActionStepComponent.defaultProps = {
    icon: undefined,
    action: undefined,
};

export default ActionStepComponent;
